import * as React from "react";
import { Datagrid, TextField, BooleanField, TextInput } from "react-admin";
import { ExcelExport } from "../../../../src/Helper/ExportExcel";
import { SourceVwUser } from "../../../../src/Constants/Source";
import { ReliabilityExclusionPnExcelName, ReliabilityExclusionPnHeader } from "./Costants/Excel";
import CreatedByField from "../../../../src/Components/ReferenceFields/CreatedBy/CreatedByField";
import { CustomDateField } from "../../../Components/CustomDateField";
import { DetailButton } from "../../../../src/Components/DetailButton";
import { SourceReliabilityExclusionPn } from "./Source";
import PoolList from "../../../Components/PoolListComponent/PoolListComponent";

const ReliabilityExclusionPnList = props => {
  const filters = [<TextInput label="Pn" source="pn__contains" alwaysOn />];

  const ExportToExcel = (records, fetchRelatedRecords) => {
    fetchRelatedRecords(records, "createdBy", SourceVwUser).then(createdBy => {
      const data = records.map(record => ({
        ...record,
        createdBy: `${record.createdBy} - ${createdBy[record.createdBy]?.name ?? ""}`,
      }));
      ExcelExport(
        ReliabilityExclusionPnHeader,
        data.map(v => [
          v.pn,
          v.excludeFailOnFit,
          v.excludePrematureFailure,
          v.excludeRogueUnit,
          v.createdBy,
          v.createdDate,
        ]),
        ReliabilityExclusionPnExcelName
      );
    });
  };

  return (
    <PoolList
      {...props}
      bulkActionButtons={true}
      exporter={ExportToExcel}
      title={"Exclusion PN List"}
      filters={filters}
    >
      <Datagrid>
        <DetailButton label="Actions" resource={SourceReliabilityExclusionPn} {...props} />
        <TextField source="pn" label={"PN"} />
        <TextField source="pnDescription" label={"PN Description"} />
        <BooleanField source="excludeFailOnFit" label={"Exclude Fail on Fit"} />
        <BooleanField source="excludePrematureFailure" label={"Exclude Premature Failure"} />
        <BooleanField source="excludeRogueUnit" label={"Exclude Rogue Unit"} />
        <CreatedByField source="createdBy" link={false} />
        <CustomDateField source="createdDate" showTime />
        <CreatedByField source="updatedBy" link={false} />
        <CustomDateField source="updatedDate" showTime />
      </Datagrid>
    </PoolList>
  );
};

export default ReliabilityExclusionPnList;
